<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF1313" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap>
      <v-flex xs12 pb-2 pt-5 pt-sm-0 pt-md-0>
        <v-tabs
          v-model="tabValue"
          centered
          background-color="#202020"
          center-active
          fixed-tabs
          dark
          active-class="act"
          class="nonact"
          show-arrows
        >
          <v-tab
            @click="changeRequest(type.val)"
            v-for="(type, key) in productTypeList"
            :key="key"
          >
            <!-- <span class="ibmsemibold"> -->
            <span class="text-none act"> {{ type.name }}</span>
          </v-tab>
        </v-tabs>
      </v-flex>
      <!-- <v-flex xs12 pa-2 align-self-center text-left>
        <span class="ibmmedium appColor">{{ totalProducts }} Product(s)</span>
      </v-flex> -->
    </v-layout>
    <v-layout wrap justify-start pt-0 px-4>
      <v-flex xs12>
        <v-layout pt-3 wrap justify-space-between>
          <v-flex xs12 sm3 md3 lg12 xl12>
            <v-layout wrap justify-space-between>
              <!-- <v-flex xs3 sm2 lg1 text-left align-self-center>
                <v-img
                  src="./../../../assets/Images/agogo.png"
                  contain
                  height="30px"
                ></v-img>
              </v-flex> -->
              <v-flex xs6 sm10 lg4 text-left pl-0 align-self-center>
                <span
                  v-if="tabValue == 0"
                  :style="
                    $vuetify.breakpoint.name == 'xs'
                      ? 'font-family: poppinssemibold;font-size: 15px;color: #1c1c1c;'
                      : 'font-family: poppinssemibold;font-size: 18px;color: #1c1c1c;'
                  "
                >
                  <span class="appColor">
                    {{ data.orderStatusPending }} Order Status Pending</span
                  >
                </span>
              </v-flex>
              <!-- <v-spacer></v-spacer>
              <v-spacer></v-spacer> -->
              <v-flex :xs12="tabValue!=0?true:false" :xs6="tabValue==0?true:false" sm10 lg2 text-left pl-0 align-self-center text-right>
                <v-select
                  outlined
                  dense
                  rounded
                  color="#FF1313"
                  placeholder="Filter"
                  v-model="filter"
                  :items="filterList"
                  item-text="name"
                  item-value="val"
                  item-color="#FF1313"
                  hide-details
                  class="text-left ibmsemibold"
                >
                  <template v-slot:item="{ item }">
                    <span class="ibmmedium text-left">
                      {{ item.name }}
                    </span>
                  </template>
                </v-select>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout
      wrap
      justify-start
      pt-4
      px-2
      pl-xl-4
      v-for="(item, i) in orders"
      :key="i"
    >
      <v-flex xs12 text-left pb-4 pl-2>
        <span
          style="font-family: opensansbold; font-size: 20px; color: #808080"
        >
          {{ formatDate(item.order_date) }}
        </span>
      </v-flex>
      <v-flex xs12 sm6 md6 lg4 xl4 text-start pa-2>
        <PendingOrdersItem v-bind:storage="item" />
      </v-flex>
      <v-flex xs12 py-2>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center v-if="orders.length < 1">
      <v-flex xs12>
        <span
          style="font-family: poppinsregular; font-size: 20px; color: #000000"
        >
          Oops! No Orders Found
        </span>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import PendingOrdersItem from "./pendingOrdersItem";
export default {
  components: {
    PendingOrdersItem,
  },
  data() {
    return {
      tabValue:0,
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      orders: [],
      data: [],
      productOrderStatus: null,
      productType: "",
      productTypeList: [
        {
          name: "Recent Orders",
          val: "ordered",
        },
        {
          name: "Packed",
          val: "packed",
        },
        {
          name: "Shipped",
          val: "shipped",
        },
        {
          name: "Out for Delivery",
          val: "outfordelivery",
        },
        {
          name: "Delivered",
          val: "delivered",
        },

        {
          name: "Cancelled by Seller",
          val: "cancelledbyseller",
        },

        {
          name: "Cancelled",
          val: "cancelled",
        },
        {
          name: "Return",
          val: "returned",
        },
      ],
      filter: "",
      filterList: [
        {
          name: "Today",
          val: "today",
        },
        {
          name: "This Week",
          val: "thisweek",
        },
        {
          name: "This Month",
          val: "thismonth",
        },
        {
          name: "Last 6 Months",
          val: "lastsixmonths",
        },
        {
          name: "This Year",
          val: "thisyear",
        },

        {
          name: "All",
          val: "",
        },
      ],
    };
  },
  watch: {
    filter() {
      this.getData();
    },
  },
  beforeMount() {
    this.productOrderStatus = "ordered";
    if (this.$route.query.tab == "shipped") {
      this.productOrderStatus = "shipped";
      this.tabValue = 2;
    }
    if (this.$route.query.tab == "cancelled") {
      this.productOrderStatus = "cancelled";
      this.tabValue = 6;
    }
    this.getData();
  },
  methods: {
    changeRequest(val) {
      this.productOrderStatus = val;
      this.getData();
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/seller/ordered/products/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          productOrderStatus: this.productOrderStatus,
          filterType: this.filter,
          // productOrderStatus: "ordered",
          // productOrderStatus: this.$route.query.productOrderStatus,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.orders = response.data.data;
            this.data = response.data;
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      var defDate = new Date(item);
      defDate = defDate.toString().slice(0, 15);
      var today = new Date();
      today = today.toString().slice(0, 15);

      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday = yesterday.toString().slice(0, 15);

      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(0, 4) + day + " " + dt.slice(4, 7) + " " + year;

      if (today == defDate) {
        return "Today";
      } else if (yesterday == defDate) {
        return "Yesterday";
      } else {
        return strTime;
      }
    },
  },
};
</script>

<style scoped>
.act {
  color: white;
  font-family: ibmbold !important;
}
.nonact {
  color: white !important;
  font-family: poppinsthin !important;
}
</style>
